import {
  Button,
  DatePicker,
  Drawer,
  Form,
  Input,
  InputNumber,
  Select,
  Space,
} from "antd";
import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import moment from "moment";
import { NotificationInfo } from "../../../context";
// import {
//   PermissionInfo,
//   NotificationInfo,
//   UserInfo,
// } from "../../../../../context";

const EditAdditionalServiceStatus = ({
  open,
  close,
  selectedData,
  getAddtionalServiceList,
}) => {
  //   console.log("selectedBookService: ", selectedBookService);
  const [form] = Form.useForm();
  const [loadings, setLoadings] = useState(false);
  //   const { userData } = useContext(UserInfo);
  //   const [selectedBooked, setSelectedBooked] = useState(
  //     selectedData !== null && selectedData.is_booked
  //   );
  //   const [selectedBookedCategory, setSelectedBookedCategory] = useState(
  //     selectedData !== null && selectedData.booked_category
  //   );
  //   const [selectedMethod, setSelectedMethod] = useState(
  //     selectedData !== null && selectedData.downpayment_method
  //   );
  const { rerunNotif } = useContext(NotificationInfo);
  //   const { permissionList } = useContext(PermissionInfo);

  const handleEditStatus = (values) => {
    const formdata = new FormData();
    formdata.append("id", selectedData !== null && selectedData.id);
    for (const name in values) {
      formdata.append(name, values[name]);
    }
    setLoadings(true);
    axios
      .post("user/merchant/update/room-status", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Update room status successfully.");
          setTimeout(() => {
            close();
            setLoadings(false);
            getAddtionalServiceList();
          }, 1000);
        }
      })
      .catch((error) => {
        setLoadings(false);
      });
  };

  return (
    <Drawer
      title="Update Room Status"
      width={300}
      onClose={close}
      open={open}
      bodyStyle={{
        paddingBottom: 80,
      }}
    >
      {selectedData !== null && (
        <>
          {console.log("selectedData: ", selectedData)}
          <Form
            form={form}
            layout="vertical"
            name="edit-booked-service3"
            // initialValues={{
            //   service_status_abbreviation:
            //     selectedData.service_status_abbreviation,
            // }}
            onFinish={handleEditStatus}
            autoComplete="off"
          >
            <Space direction="vertical" style={{ width: "100%", margin: 0 }}>
              <Form.Item
                name="service_status_abbreviation"
                label="Room Status"
                rules={[
                  {
                    required: true,
                    message: "Required",
                  },
                ]}
              >
                <Select placeholder="Select" size="large">
                  {selectedData.service_status_abbreviation === "VD" && (
                    <Select.Option value={"VC"}>Vacant & Clean</Select.Option>
                  )}
                  <Select.Option value={"VR"}>Vacant & Ready</Select.Option>
                </Select>
              </Form.Item>
            </Space>

            <Form.Item style={{ marginTop: "20px" }}>
              <Button
                type="primary"
                loading={loadings}
                htmlType="submit"
                style={{ width: "100%", borderRadius: "20px" }}
              >
                {!loadings ? "Update" : "Loading"}
              </Button>
            </Form.Item>
          </Form>
        </>
      )}
    </Drawer>
  );
};

export default EditAdditionalServiceStatus;
